import React, { FunctionComponent, useMemo } from 'react';
import css from '@components/GameCard/GameCard.module.less';
import Image from '@components/Image';
import { CloseCircleOutlined, LinkOutlined } from '@ant-design/icons';
import { Typography } from 'antd';
import useTranslate from '@hooks/useTranslate';
import componentContent from '@components/GameCard/GameCard.content.json';
import { setList } from '@stores/gamesSelector';
import { goTo } from '@helpers/navigation';
import IGame from '@interfaces/IGame';
import cn from 'classnames';

interface GameCardCellProps {
  game?: IGame;
  text: string;
  urlImg: string;
  synonyms?: string[];
  isLink?: boolean;
  isEmpty: boolean;
}

const GameCardCell: FunctionComponent<GameCardCellProps> = ({
  game,
  text,
  synonyms,
  urlImg,
  isLink = false,
  isEmpty = false,
}) => {
  const content = useTranslate(componentContent);

  const renderValidLink = useMemo(() => {
    if (isLink && text)
      return (
        <div className={cn(css.metaLine, css.meta)}>
          <Typography.Link
            copyable={{ text: text }}
            href={text}
            target='_blank'
            className={cn(css.metaLineItem, 'clickable')}
          >
            <span className={css.metaIcon}>
              <LinkOutlined />
            </span>
            <span>URL</span>
          </Typography.Link>
        </div>
      );
    return null;
  }, [isLink, text]);

  const renderNovalidLink = useMemo(() => {
    if (isLink && !text)
      return (
        <div>
          <div className={css.rowTitle}>{!isEmpty ? 'NO URL' : content.notFound}</div>

          <Typography.Text
            type='secondary'
            className={css.description}
          >
            {!isEmpty ? synonyms?.join(', ') : content.notFoundDesc}
          </Typography.Text>
        </div>
      );
    return null;
  }, [isLink, text]);

  const renderText = useMemo(() => {
    if (!isLink && text)
      return (
        <div>
          <div className={css.rowTitle}>{!isEmpty ? text : content.notFound}</div>

          <Typography.Text
            type='secondary'
            className={css.description}
          >
            {!isEmpty ? synonyms?.join(', ') : content.notFoundDesc}
          </Typography.Text>
        </div>
      );
    return null;
  }, [isLink, text]);

  const image = () => {
    if (isLink) return null;
    if (!isEmpty)
      return (
        <Image
          url={urlImg}
          className={css.rowImage}
        />
      );

    return <CloseCircleOutlined className={css.rowImage} />;
  };

  return (
    <div className={css.row}>
      <div
        onClick={() => {
          game && setList([game]);
          goTo('postList', undefined, { gameId: game?.id });
        }}
        className='clickable'
      >
        {image()}
      </div>
      {renderValidLink}
      {renderNovalidLink}
      {renderText}
    </div>
  );
};

export default GameCardCell;
